import { useContext, useState } from "react";
import { AuthContext } from '../context/AuthContext';
import { getProductBalance } from "../api/processor";
import { getShortcuts } from "../api/shortcut";
import { useNavigate } from "react-router";
import Swal from "sweetalert2";


export const useBillPaymentArcus = ()=>{


    const route = useNavigate()

    const {tokenDecoded,setLoading,setAlert,checkToken} = useContext(AuthContext);

    const [productsShortcuts,setShortcutsProducts] = useState(null);


    const getProductDisplayType = (product)=>{
        //console.log(product);
    

        //Retorar TOPUPS (Deberia con las otras condiciones pero se construyo asi. habra que modificarla)
        if(product.typeOfProductId == "TOPUPS"){
            return 'TOPUPS';
        }

        //Producto BillPayment con lista de precios desplegable
        if(product?.requirements?.availableAmount?.length >= 1){
            return 'AMOUNT_DROPDOWN_LIST'
        }

        //Producto BillPayment con cantidad variable estableciendo un minimo y un maximo 
        if(product?.requirements?.maximumAmount && product?.requirements?.minimumAmount ){
            return 'FREE_AMOUNT_PRODUCT'
        }

       //Producto BillPayment del que puede consultarse su balance
       if(product?.requirements?.canCheckBalance == true){
           if(product?.requirements?.supportPartialPayments == true){
               return 'FREE_AMOUNT_WITH_BALANCE'
           }else{
               return 'AMOUNT_BALANCE'
           }
       }

       //Producto barcode
       return 'OTHER';

    }

    const goToTransactionCustomizationScreen = async(product)=>{
        let type = getProductDisplayType(product);

        if(type == "TOPUPS" ){
            route('/RechargeOptionScreen',{product:product});
        }

        if(type == "AMOUNT_DROPDOWN_LIST" ){
            route('/AmountDropdownListScreen',{state:{product:product}});
        }

        if(type == "FREE_AMOUNT_WITH_BALANCE" || type == "AMOUNT_BALANCE" ){
            if(product?.product?.accountNumber){
                await consultProductBalance(product,product.product.accountNumber)
            }else{
                route('/ConsultAccountScreen',{state:{product:product}});
            }
        }
    
        if(type == "FREE_AMOUNT_PRODUCT" ){
            route('/CaptureAmountScreen',{product:product});
        }
    }


    const goToTransactionDetails = async({productId,originCurrencyId, destinationCurrencyId, paymentAccountNumber, amount, description="",comeFromFavorites=false},navigation) => {
        
        //console.log(product);
        let params = {
            data: {
                originCurrencyId: originCurrencyId,
                destinationCurrencyId: destinationCurrencyId,
                sourceDirectoryId: JSON.parse(localStorage.getItem("tokenDecoded")),
                products: [
                    {
                        id: productId,
                        amount: amount,
                        paymentAccountNumber: paymentAccountNumber,
                    }
                ]
            },
            description: description,
            comeFromFavorites:comeFromFavorites
        }

        route('/BillScreen2', { state:{
            data: params.data,
            comeFromFavorites: params.comeFromFavorites
        }})
        
       //route('/BillScreen2',{state:{params}} );
  }


  const consultProductBalance = async(product,accountNumber)=>{
    checkToken()
    setLoading(true);
    let productId = product?.id ? product?.id : product?.product?.id

    try {
        let resp = await getProductBalance(productId,accountNumber);
        if(resp.code == "PROCESS_OK"){
            route('/ProductBalanceScreen',{state:{product, balance:resp.data}} );
        }

    } catch (error) {
        if (error.response.data.code == "INVALID_ACCOUNT_NUMBER"){
            Swal.fire({
                showCloseButton: true,
                title: 'Advertencia',
                text: "El número de cuenta proporcionado es invalido",
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#fd6e0d',
                iconColor: "#fd6e0d",
                confirmButtonText: 'Entendido'
              })
        } else {
            Swal.fire({
                showCloseButton: true,
                title: 'Advertencia',
                text: "Su solicitud no puede ser procesada",
                icon: 'warning',
                showCancelButton: false,
                confirmButtonColor: '#fd6e0d',
                iconColor: "#fd6e0d",
                confirmButtonText: 'Entendido'
              })
        }
    }
    setLoading(false);
       
  }

  const validateMinMaxAmount = (product,amount)=>{

    if(parseFloat(amount) >= parseFloat(product.requirements.minimumAmount) && parseFloat(amount) <=  product.requirements.maximumAmount ){
        return true
    }else{
        Swal.fire({
            showCloseButton: true,
            title: 'Advertencia',
            text: `La cantidad especificada debe ser entre ${product.requirements.minimumAmount} y ${product.requirements.maximumAmount}`,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#fd6e0d',
            iconColor: "#fd6e0d",
            confirmButtonText: 'Entendido'
          })
        return false;
    }

  }

  const sendToFinalScreen = (typeOfProduct,data,navigation)=>{
    route('/GiftScreen' );
  }

  const getProductsShortcuts = async()=>{
    checkToken()
    let resp = {}
    try {

        resp = await getShortcuts('PRODUCT');
        //console.log('VER SHORCUTS')
        setShortcutsProducts(resp.data.data);
      } catch (error) {
        setShortcutsProducts([]);
         //console.log(error.request)
         //console.log('falla')
        //console.log(error);
      }
      
      return resp
   
     
  }

  return {
    productsShortcuts,
    goToTransactionCustomizationScreen,
    goToTransactionDetails,
    consultProductBalance,
    validateMinMaxAmount,
    sendToFinalScreen,
    getProductsShortcuts}

}